import { useEffect, useState } from "react";
import axiosInstance from "src/utils/axios";

const useRanks = () => {
  const [ranks, setRanks] = useState([]);
  const fetchRanks = async () => {
    try {
      const { data, status } = await axiosInstance.get("api/user/allranks");
      if (status === 200) {
        setRanks(data.data);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    fetchRanks();
  }, []);
  return ranks;
};

export default useRanks;
